import { toBytes } from "../../../utils/bytes.mjs";
export default {
  serialize(string) {
    return toBytes(string);
  },
  deserialize(buffer) {
    return buffer.toString();
  }
};
//# sourceMappingURL=string.mjs.map